// Timer.js
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Starttask,
  stopTimer,
  incrementTimer,
  resetPopupCount,
  setPopupCount,
  resetTimer,
} from "../Slices/timerslice";
import { getAllWorkHistoryByID, updateWorkHistoryThunk } from "../Slices/orderSlice";
import { addLatestReports } from "../Slices/employeereportslice";
import { useNavigate } from "react-router-dom";
import { AntdButton } from "../blueplanitUtils/InputField";
import { updateBreakAsync } from "../Slices/attendenceSlice";
import { fetchAllRecordsAsync } from "../Slices/Thunk/LoginThunk";
import { getAllLeadWorkHistory } from "../Slices/salesSlice";
import { Modal } from "antd";
import { useHeaderScale } from "../blueplanitUtils/useHeaderScale";
function formatDateTime(receivedDate) {
  // Ensure the input is a valid Date object
  const now = new Date(receivedDate);
 
  // Format the date as DD/MM/YYYY
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = now.getFullYear();
 
  // Format the time as HH:mm:ss AM/PM
  let hours = now.getHours();
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
 
  if (hours > 12) {
    hours -= 12; // Convert to 12-hour format
  } else if (hours === 0) {
    hours = 12; // Handle midnight
  }
 
  hours = String(hours).padStart(2, "0");
 
  // Combine everything into the desired format
  return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
}
const formatTime = (timestamp) => {
  const totalSeconds = Math.floor((Date.now() - timestamp) / 1000);
  const days = Math.floor(totalSeconds / (3600 * 24));
  const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
 
  return (
    <span>
      {days > 0 && <span>{days}d </span>}
      {hours.toString().padStart(2, "0")}:{minutes.toString().padStart(2, "0")}:
      {seconds.toString().padStart(2, "0")}
    </span>
  );
};
 
export const formatloginTime = (timeString) => {
 
  if (typeof timeString === "string") {
    const startTime = new Date(timeString).getTime();
    const currentTime = new Date().getTime();
    const totalSeconds = Math.floor((currentTime - startTime) / 1000);
 
    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
 
    return (
      <span>
        {days > 0 && <span>{days}d </span>}
        {hours.toString().padStart(2, "0")}:
        {minutes.toString().padStart(2, "0")}:
        {seconds.toString().padStart(2, "0")}
      </span>
    );
  } else {
    const startTime = timeString;
    const currentTime = new Date().getTime();
    const totalSeconds = Math.floor((currentTime - startTime) / 1000);
 
    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
 
    return (
      <span>
        {days > 0 && <span>{days}d </span>}
        {hours.toString().padStart(2, "0")}:
        {minutes.toString().padStart(2, "0")}:
        {seconds.toString().padStart(2, "0")}
      </span>
    );
  }
 
};
 
const Timer = () => {
  const scale = useHeaderScale();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isRunning, time, department, task, loginTime, requestId, breakTimeToday, popupCount, LoginMessgae
 
  } = useSelector((state) => state.timer);
 
  const RequestInfo = useSelector((state) => state?.orders?.singleOrder);
  const SalesInfo = useSelector((state) => state?.sales?.sale);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
 
  const [showTaskPopup, setShowTaskPopup] = useState(false);
  const [paused, setPaused] = useState(false);
  const [taskExceeded, setTaskExceeded] = useState(false);
  const [popupType, setPopupType] = useState(null);
  // const [popupCount, setPopupCount] = useState(1);
 
 
 
 
 
  const allRecords = useSelector((state) => state.Attendence.AllRecords);
 
  const userid = loginUser?.id;
 
  const specificEmployee = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const handleStartButtonClick = async () => {
    const now = Date.now();
 
    const payload = {
      task: "Available",
      time: now,
      department: "",
      requestId: "",
    };
 
    const Reportpayload = {
      userId: userid,
      employeeName: specificEmployee.firstname + ' ' + specificEmployee.lastname,
      emailId: specificEmployee.email,
      requestId: 'N/A',
      reportingTo: specificEmployee.reportingManager || 'N/A',
      clientName: 'Blueplanit',
      requestIds: 'N/A',
      processType: '',
      taskType: "Available",
      billable: "No",
      service: "N/A",
      requestCompleted: "N/A",
      startTime: now.toString(),
      startingTime: formatDateTime(now),
      status: 'Pending',
      endTime: '',
      overrideHistory: [],
      department: department
    };
 
    try {
      if (task === 'Break') {
        const breakIn = localStorage.getItem('breakIn');
        if (!breakIn) {
          console.warn('No break start time found.');
          return;
        }
        const breakOut = now.toString();
        const attendanceRecord = allRecords.find(
          (record) => record.status === true && record.punchOut === null
        );
 
        if (attendanceRecord?.id) {
          await dispatch(updateBreakAsync({
            attendanceId: attendanceRecord.id,
            breakIn,
            breakOut,
          }))
          await dispatch(fetchAllRecordsAsync({ userId: userid }));
 
          localStorage.removeItem('breakIn');
        } else {
          console.warn("No active attendance record found for today.");
        }
      }
      const valuesObject = {
        userId: userid,
        emailId: specificEmployee.email,
        requestId: "",
        clientName: "Blueplanit",
        processType: "",
        taskType: "Available",
        email: "",
        subject: "",
        body: "",
        startTime: now.toString(),
        endTime: "",
        department: department
      };
 
      await dispatch(updateWorkHistoryThunk(valuesObject)).unwrap();
 
      dispatch(addLatestReports(Reportpayload));
 
      if (RequestInfo?.id) {
        dispatch(getAllWorkHistoryByID(RequestInfo?.id));
      }
      if (SalesInfo?.id) {
        dispatch(getAllLeadWorkHistory(SalesInfo?.id));
      }
      localStorage.removeItem("department");
      localStorage.removeItem("task");
      localStorage.removeItem("requestId");
    } catch (err) {
      console.error("Error updating work history or break:", err);
    }
 
    localStorage.setItem("time", now);
    dispatch(resetPopupCount());
    dispatch(Starttask(payload));
  };
 
  useEffect(() => {
    let interval = null;
 
 
    if (isRunning && !paused) {
      interval = setInterval(() => {
        dispatch(incrementTimer());
 
        // Check for task popup
        if (task !== "Available" && time) {
          const now = Date.now();
          const elapsedSinceTaskStart = now - time;
          const threshold = popupCount * 2 * 60 * 60 * 1000;
 
          if (!showTaskPopup && elapsedSinceTaskStart >= threshold) {
            setShowTaskPopup(true);
            setPaused(true);
            setPopupType("task");
          }
        }
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isRunning, time, dispatch, task, showTaskPopup, paused, loginTime, userid, breakTimeToday, taskExceeded, navigate]);
 
  useEffect(() => {
    if (!isRunning || task === "Available" || time === 0) {
      setTaskExceeded(false);
      setShowTaskPopup(false);
      setPaused(false);
      setPopupType(null);
    }
  }, [isRunning, task, time]);
 
  useEffect(() => {
    if (task === "Break" && breakTimeToday >= 1 * 60 * 60 && !showTaskPopup) {
      setShowTaskPopup(true);
      setPaused(true);
      setPaused(true);
      setPopupType("break");
    }
  }, [task, breakTimeToday, showTaskPopup]);
 
  useEffect(() => {
    if (task === "Break" && breakTimeToday >= 1 * 60 * 60) {
      setShowTaskPopup(true);
      setPaused(true);
      setPopupType("break");
    }
  }, []);
 
  const styles = makeStyles(scale);

  return (
    <div style={styles.container}>
 
      {/* <p style={{ color: 'red' }}>{LoginMessgae}</p> */}
 
      <div style={styles.timeDisplay}>
        <p style={{ fontSize: `${9 * scale}px`, margin: "0" }}>Login Time</p>
        {formatloginTime(loginTime)}
      </div>
      {requestId && (
        <div style={styles.task}>
          <h6 style={{ color: "white", fontSize: `${9 * scale}px` }}>Working Id</h6>
          <p style={{ fontSize: `${0.7 * scale}rem`, margin: 0 }}>{requestId}</p>
        </div>
      )}
      {department && (
        <div style={styles.task}>
          <h6 style={{ color: "white", fontSize: `${9 * scale}px` }}>Department</h6>
          <p style={{ fontSize: `${0.7 * scale}rem`, margin: 0 }}>{department}</p>
        </div>
      )}
      <div style={styles.task}>
        <h6 style={{ color: "white", fontSize: `${9 * scale}px` }}>Task</h6>
        <p style={{ fontSize: `${0.7 * scale}rem`, margin: 0 }}>{task}</p>
      </div>

      <div style={styles.timeDisplay}>
        <p style={{ fontSize: `${9 * scale}px`, margin: "0" }}>{task} Time</p>
        {formatTime(time)}
      </div>

      <div style={styles.buttonContainer}>
        <AntdButton
          style={{ ...styles.button, ...styles.startButton }}
          onClick={() => dispatch(stopTimer())}
          label="Start"
        />
        {task !== "Available" && (
          <AntdButton
            style={{ ...styles.button, ...styles.stopButton }}
            onClick={() => handleStartButtonClick()}
            disabled={task === "Available"}
            label="Stop"
          />
        )}
      </div>
 
      {showTaskPopup && (
        <Modal
          open={showTaskPopup}
          footer={null}
          closable={false}
          centered
          maskClosable={false}
          keyboard={false}
          style={{ zIndex: 10000 }}
          maskStyle={{
            backgroundColor: "rgba(0,0,0,0.8)",
            pointerEvents: "auto"
          }}
        >
          {popupType === "task" ? (
            <>
              <h3>Task Time Exceeded</h3>
              <p>Your current task has exceeded 2 hours.</p>
            </>
          ) : (
            <>
              <h3>Break Time Exceeded</h3>
              <p>You have exceeded your 1-hour daily break limit.</p>
            </>
          )}
 
          <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
            <AntdButton
              label="Continue"
              htmlType="button"
              disabled={popupType === "break"}
              onClick={() => {
                setShowTaskPopup(false);
                setPaused(false);
                if (popupType === "task") {
                  dispatch(setPopupCount(popupCount + 1));
                  const now = Date.now();
                  const elapsedSinceTaskStart = now - time;
                  const threshold = popupCount * 2 * 60 * 60 * 1000;
 
                  if (elapsedSinceTaskStart > threshold) {
                    dispatch(Starttask({
                      task,
                      time,
                      department,
                      requestId,
                    }));
                  }
                }
                setPopupType(null);
              }}
              style={{ background: "#4BB543", color: "#fff" }}
            />
            <AntdButton
              label="Stop"
              onClick={() => {
                setShowTaskPopup(false);
                setPaused(false);
                setTaskExceeded(false);
                setPopupType(null);
                handleStartButtonClick();
              }}
              style={{ background: "#fe3c3c", color: "#fff" }}
            />
          </div>
        </Modal>
      )}
    </div>
  );
};
 
// styles is now a function so Timer can pass the current scale
const makeStyles = (scale) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "white",
  },
  timeDisplay: {
    fontSize: `${0.7 * scale}rem`,
    width: `${70 * scale}px`,
  },
  buttonContainer: {
    display: "flex",
    gap: `${5 * scale}px`,
    margin: `0 ${5 * scale}px`,
  },
  button: {
    fontSize: `${0.75 * scale}rem`,
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background-color 0.3s",
    padding: `${2 * scale}px ${6 * scale}px`,
  },
  startButton: {
    backgroundColor: "#4BB543",
    lineHeight: `${14 * scale}px`,
    fontSize: `${12 * scale}px`,
    padding: `${4 * scale}px ${8 * scale}px`,
  },
  stopButton: {
    backgroundColor: "#fe3c3c",
  },
  task: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    margin: `0 ${4 * scale}px`,
    justifyContent: "center",
  },
});
 
export default Timer;
 
 